import React from "react";
import { usePmsTheme } from "../../../Components/PmsThemeContext";
import { isExplicitZeroPrice } from "../../utils/complimentaryStock";
import { getDeliveryNotePriceTranslator } from "./deliveryNotePriceMessages";
import "./ComplimentaryStock.css";

export default function ComplimentaryPriceField({ value, isComplimentary = false, priceStatus, priceEstimateSource,
  onPriceOptions, className = "", ...inputProps }) {
  const { languageId } = usePmsTheme();
  const t = getDeliveryNotePriceTranslator(languageId);
  const confirmed = isComplimentary && isExplicitZeroPrice(value);
  const estimated = !confirmed && priceStatus === "estimated";
  const missing = !confirmed && priceStatus === "missing";
  const label = t(confirmed ? "No cost" : estimated
    ? priceEstimateSource === "tender" ? "Estimate · Tender"
      : priceEstimateSource === "last_purchase" ? "Estimate · Last purchase" : "Estimated"
    : "Missing");
  const description = t(confirmed ? "Confirmed complimentary stock"
    : estimated ? "Estimated price awaiting confirmation" : "Missing price awaiting confirmation");
  const editable = typeof onPriceOptions === "function" && !inputProps.readOnly && !inputProps.disabled;
  const hasStatus = confirmed || estimated || missing;
  const showBadge = hasStatus && !editable;
  const optionLabel = confirmed ? t("Complimentary") : missing ? t("Unknown") : label;
  return (
    <div className={`complimentary-price${showBadge && !estimated ? " complimentary-price--confirmed" : ""}${estimated ? " complimentary-price--estimated" : ""}`}>
      <div className="complimentary-price__input">
      <input type="number" step="0.00000001" min="0" {...inputProps} value={value ?? ""}
        className={`form-control ${className}`} title={hasStatus ? description : inputProps.title} />
      {showBadge && !estimated && <span className="complimentary-price__badge" title={description}>{label}</span>}
      </div>
      {showBadge && estimated && <span className="complimentary-price__badge" title={description}>{label}</span>}
      {editable && <button type="button"
        className={`complimentary-price__options${hasStatus ? " complimentary-price__options--selected" : ""}`}
        aria-haspopup="dialog" onClick={onPriceOptions} title={hasStatus ? description : undefined}>
        {hasStatus ? optionLabel : t("Price options")}
      </button>}
    </div>
  );
}
